export const defaultSeriesValueWidgetData = {
  labels: [],
  series: []
};